/** Model for SliderConfiguration*/
export class SliderConfiguration {
  public Width: any;
  public IsSilderReadOnly: boolean = false;
}
